import { useEffect, useState, useContext } from "react";
/* eslint-disable camelcase */
import { Outlet, UNSAFE_NavigationContext, useParams } from "react-router-dom";
import type { History } from 'history';

import { SMALL_MEDIA_QUERY } from "~/const";
import { loadLanguage } from "~/providers/lang";
import { layoutStore } from "~/stores/layout";
import { getParams } from "~/utils/utils";
import { setDesc } from "~/utils/seo";
import { useLang } from "~/hooks/useLang";
import { userStore } from "~/stores/user";

export default function InitLayout() {
	const { setLayout } = layoutStore(layoutState => ({
		setLayout: layoutState.setLayout,
	}));
	const { meLoaded } = userStore(userState => ({
		meLoaded: userState.userLoad.meLoaded,
	}));
	const [isLoaded, setLoaded] = useState(false);
	const params = getParams(useParams());
	const { lang } = useLang();
	const navigator = useContext(UNSAFE_NavigationContext).navigator as History;

	async function loadLang() {
		try {
			await loadLanguage(lang);

			setLoaded(true);
			setDesc();
		} catch (exc) {
			/* eslint-disable no-console */
			console.log(exc);
		}
	}

	function bindHistoryListen() {
		navigator.listen(() => {
			const layoutState = layoutStore.getState();

			if (layoutState.layout.showLeftMenu) {
				layoutState.setShowLeftMenu(false);
			}
		});
	}

	useEffect(() => {
		const media = window.matchMedia(SMALL_MEDIA_QUERY);

		setLayout(media.matches);

		const listener = () => {
			setLayout(media.matches);
		};

		media.addEventListener("change", listener);

		return () => {
			media.removeEventListener("change", listener);
		};
	}, []);

	useEffect(() => {
		if (meLoaded) {
			loadLang();
		}
	}, [lang, meLoaded]);

	useEffect(() => {
		bindHistoryListen();
	}, []);

	return isLoaded ? <Outlet context={{ params }} /> : null;
}
